import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { XCircle } from "lucide-react";

export default function PayCancel() {
  return (
    <Layout>
      <section className="min-h-[60vh] flex items-center justify-center px-6 py-24">
        <div className="max-w-xl w-full text-center">
          <XCircle size={64} className="mx-auto text-[#0B1215] mb-6" />
          <div className="font-mono-label text-[#FF5A36] mb-3">· PAYMENT CANCELLED</div>
          <h1 className="font-display text-4xl tracking-tighter mb-4">No worries.</h1>
          <p className="text-[#495057]">
            The payment was cancelled. Your invoice link stays valid — pay whenever you're ready, or
            give Rob a call on 07346 812 685.
          </p>
          <Link
            to="/"
            className="mt-10 inline-flex items-center gap-2 bg-[#0B1215] hover:bg-[#FF5A36] text-[#F8F9FA] px-6 py-3 font-mono-label transition-colors"
          >
            Back to home →
          </Link>
        </div>
      </section>
    </Layout>
  );
}
